import { useState, useEffect } from 'react';

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(
    value?.toLowerCase() || '',
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value?.toLowerCase() || '');
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};
export default useDebounce;
